import { render, staticRenderFns } from "./PopupTrend.vue?vue&type=template&id=54199276&scoped=true&"
import script from "./PopupTrend.vue?vue&type=script&lang=js&"
export * from "./PopupTrend.vue?vue&type=script&lang=js&"
import style0 from "./PopupTrend.vue?vue&type=style&index=0&id=54199276&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54199276",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/huangdie/work-gwdang/plt_web/template/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54199276')) {
      api.createRecord('54199276', component.options)
    } else {
      api.reload('54199276', component.options)
    }
    module.hot.accept("./PopupTrend.vue?vue&type=template&id=54199276&scoped=true&", function () {
      api.rerender('54199276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "metro/components/PopupTrend.vue"
export default component.exports